
class SearchUserModel {
  constructor(){
      this.id = undefined;
      this.firebaseId = undefined;
      this.name = undefined;
      this.nationality = undefined;
      this.email = undefined;
      this.address = undefined;
      this.number = undefined;
      this.userType = undefined;
      this.isActivated = undefined;
      this.isAssessmentTherapist = undefined;
      this.isSoftDeleted = undefined;
      this.patientId = undefined;
      this.therapistId = undefined;
      
      this.pagingParams = {
          pageNumber : undefined,
          pageSize : undefined
      }
  }
}

export default SearchUserModel;